import { atom } from 'jotai';

const pdfScaleAtom = atom(1);

export { pdfScaleAtom };